// assets
import {
  IconKey,
  IconUserPlus,
  IconUser,
  IconClipboardText,
  IconQuestionMark,
  IconDeviceAnalytics,
  IconAdjustments,
  IconCalculator,
} from "@tabler/icons";

const icons = { IconKey, IconUserPlus, IconUser };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const about = {
  id: "about_englinelite",
  //   title: "About Engine Lite",
  //   caption: "short description",
  type: "group",
  group: [1, 2, 3, 4, 5],
  children: [
    {
      id: "about",
      title: "About Engine Lite",
      type: "collapse",
      icon: IconQuestionMark,

      children: [
        {
          id: "about_englinelite",
          title: "Engline Lite",
          type: "item",
          url: "about_englinelite",
          icon: IconDeviceAnalytics,
          breadcrumbs: false,
          group: [1, 2, 3, 4, 5],
        },
        {
          id: "about_optimizer",
          title: "Optimizer",
          type: "item",
          url: "about_optimizer",
          icon: IconAdjustments,
          breadcrumbs: false,
          group: [1, 2, 3, 4, 5],
        },
        {
          id: "about_simulator",
          title: "Simulator",
          type: "item",
          url: "about_simulator",
          icon: IconCalculator,
          breadcrumbs: false,
          group: [1, 2, 3, 4, 5],
        },
      ],
    },
  ],
};

export default about;
